import * as zod from 'zod';

import type { CameraDevice } from '@sb/messenger/auto_generated/messenger/camera_bot_service';

export const CameraState = zod.object({
  kind: zod.literal('Camera'),
  connected: zod.boolean(),
  cameraDevice: zod.custom<CameraDevice>().optional(),
});

export type CameraState = zod.infer<typeof CameraState>;
